<template>
  <ExternalList
      headline="Topic Articles"
      endpoint="/api/v2/content-topic-articles"
      :endpoint-filters="{content_topic_id: contentTopic.id}"
      :headlines="headlines"
      :filters="filters"
      :can-destroy="() => true"
      :can-update="() => true"
      :checkbox-column-width="2"
      :button-column-width="2"
      reorder-endpoint="/api/v2/content-topic-articles/priorities"
      :get-reorder-payload="data => ({content_topic_articles: data})"
      @show="contentTopicArticle => $router.push(getUrl(contentTopicArticle))"
  >
    <template v-slot:default="{ row: contentTopicArticle }">
      <td class="table__ellipsis">
        <router-link :to="getUrl(contentTopicArticle)">
          {{ contentTopicArticle.attributes.content_article_title }}
        </router-link>
      </td>

      <td class="table__ellipsis">
          {{ contentTopicArticle.attributes.portal_company_name }}
      </td>
    </template>

    <template v-slot:headline-right>
      <router-link
          class="btn btn-white btn-sm"
          style="margin-top: 4px;"
          :to="'/portals/' + portal.id + '/content/topics/' + contentTopic.id + '/articles/create'"
      >
        <i class="fa fa-plus"></i> Create
      </router-link>
    </template>

    <template v-slot:list-actions="{canUpdateSelected}">
      <li :class="{'disabled': !canUpdateSelected}">
        <a href="#add-article-tags-modal" data-toggle="modal">
          <i class="fa fa-plus"></i> Add Tags
        </a>
      </li>
    </template>

    <template v-slot:modals="{selected, update, resetSelected}">
      <AddTagsModal
          :selected="selected.map(contentTopicArticle => contentTopicArticle.attributes.content_article_id)"
          :portal="portal"
          @updated="updated($event, update, resetSelected)"
      />
    </template>
  </ExternalList>
</template>

<script>
import ExternalList from '../../../Panels/Lists/External'
import AddTagsModal from "../../ContentArticles/Modals/AddTags.vue";

export default {
  components: {AddTagsModal, ExternalList},

  props: {
    portal: {
      required: true
    },

    contentTopic: {
      required: true
    }
  },

  computed: {
    headlines() {
      return [
        {width: 12, text: 'Article'},
        {width: 8, text: 'Company'},
      ]
    },

    filters() {
      return [
        [
          {
            width: 20,
            widget: 'text',
            name: 'search',
            placeholder: 'Search...'
          },
          {
            width: 4,
            widget: 'submit'
          }
        ]
      ]
    }
  },

  methods: {
    getUrl(contentTopicArticle) {
      return '/portals/' + this.portal.id + '/content/articles/' + contentTopicArticle.attributes.content_article_id + '/edit'
    },

    updated(company, update, resetSelected) {
      update(company)

      resetSelected()
    },
  }
}
</script>
